import './footer.css'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneFlip , faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faXTwitter , faLinkedin } from '@fortawesome/free-brands-svg-icons';
import img2 from '../img/logo2.png'


function Footer() {
    const data = [
        {
            id: 1,
            class: 'facebook',
            icon: <FontAwesomeIcon icon={faPhoneFlip} className='icon'/>,
            link: 'tel:0568300288'
        },
        {
            id: 2,
            class: 'whats',
            icon: <FontAwesomeIcon icon={faWhatsapp}className='icon'/>,
            link: 'https://wa.me/966568300288'
        },
        {
            id: 3,
            class: 'mail',
            icon: <FontAwesomeIcon icon={faEnvelope} className='icon'/>,
            link: 'mailto:techweb.sa.info@gmail.com'
        },
        {
            id: 4,
            class: 'x',
            icon: <FontAwesomeIcon icon={faXTwitter}  className='icon'/>,
            link: 'https://x.com/techweb_sa_info'
        },
        {
            id: 5,
            class: 'link',
            icon: <FontAwesomeIcon icon={faLinkedin}  className='icon'/>,
            link: 'https://www.linkedin.com/company/%D8%AA%D9%83%D9%88%D9%8A%D8%A8/about/?viewAsMember=true'
        },
    ]
    const year = new Date().getFullYear(); // يحصل على السنة الحالية

  return (
    <div className='footer'>
    <div className="container">
        <div className="row">
            <div className="col-12  social-icons mt-3">
                <ul >
                {data.map((item, index) => (
                    <li className={item.class} key={index}>
                        <a href={item.link}
                        rel="noreferrer"
                        target="_blank"
                        >
                        {item.icon}
                        
                        </a>
                    </li>
                        ))}
                </ul>
            </div>
            <div className="col-12  social-icons mt-4">
            <p>
                  جميع الحقوق محفوظة لـ  
                 <img src={img2} alt="تكويب" className='techweb' /> 
                 {year}م
                </p>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Footer
